var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrameGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 312"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98",
    cx: 12.4729,
    cy: 12.4402,
    r: 10,
    stroke: "#34A853",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.0317 9.44025L11.0377 15.4402L9.2395 13.642",
    stroke: "#34A853",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameGreen);
export default __webpack_public_path__ + "static/media/Frame-green.ae7b30d61dbfa1d5cd6afca6033fbb6f.svg";
export { ForwardRef as ReactComponent };